import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-brand-goals',
  templateUrl: './dialog-brand-goals.component.html',
  styleUrls: ['./dialog-brand-goals.component.scss'],
})
export class DialogBrandGoalsComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
